import React from 'react'
import Section from './Section'
import { ContactPageNumber } from '../../constants'

export default ({ urlState, calculateViewChange, navigatePageWithState, qxData, offer, canEdit, isVehicleGrounded }) => {
  const groundedVehicleComment = 'System: vehicle grounded by dealer.'
  const comments = urlState.dealerComment ?? offer?.prospect?.dealerComment ?? (isVehicleGrounded ? groundedVehicleComment : '') ?? ''
  let uniqueViewStr = 'uniqueViewStr:' + comments
  calculateViewChange('additionalComments', uniqueViewStr)
  return (
    <Section title={'Additional Comments'} showEdit={canEdit} onClick={e => navigatePageWithState({ p: ContactPageNumber })}>
      {comments}
    </Section>
  )
}
